import { Environment } from "@/core/models/environment.model";

export const environment: Environment = {
  production: false,
  cognitoLoginUrl: 'https://dev-pacifichs-pmslite-auth-domain.auth.us-east-1.amazoncognito.com/login?client_id=2nho0nj8ckuedceqtlv4qm4kbm&response_type=code&scope=email+openid+profile&redirect_uri=https%3A%2F%2Fapi.dev.pmslite.com%2Fv2%2Fauth%2Fverify_token_cognito&lang=es',
};